import React, { useEffect } from 'react'
import Moudles from '../modules'
import { action_fetch_init_data } from '../../../../store/actions/pages/simple-landing'

import { useSelector } from 'react-redux'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Footer from '../../../layout/fragments/footer'
import BottomNavigation from '../../../layout/fragments/bottom-navigation'
import { useStore } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getCountryMessage } from '../../../../api'
import { useApp, useQuery } from '../../../hooks/common'
import BaseLayout from './layout'
// import LuckyStar from '../../../layout/fragments/luck-star'


const LoadingHome = props => {
    useStyles(classes)
    return <div className={classes.LoadingHome}>
        <div className={classes.Block2}></div>
        <div className={classes.Block2}></div>
        <div className={classes.Block2}></div>
    </div>
}

const SimpleLandingPage = props => {

    useStyles(classes)
    const store = useStore()
    const pageSimpleLanding = useSelector((state) => state.pageSimpleLanding)
    const simpleData = pageSimpleLanding?.simpleData


    const location = useLocation()

    const isApp = useApp()

    const query = useQuery();

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
            delete window.__INITIAL_STATE__
        } else {
            if (!simpleData) {
                const urlConfigs = await getCountryMessage('M1640').then(data => data.result)
                const currentConfig = urlConfigs?.[location.pathname]

                SimpleLandingPage.fetchData(store, null, { code: currentConfig?.code }).then(data => {
                    const pageData = data?.[0]
                    window.currentPage = 'landing'
                    window.pageContent = pageData?.refId
                    document.title = pageData?.title

                    if (window.GeekoSensors) {
                        window.GeekoSensors.Quick('autoTrackSinglePage', {
                            page_sort: 'landing',
                            page_title: '活动落地页',
                            page_content: pageData?.refId
                        })
                    }

                })
            }else{
                if (window.GeekoSensors) {
                    window.GeekoSensors.Quick('autoTrackSinglePage', {
                        page_sort: 'landing',
                        page_title: '活动落地页',
                        page_content: simpleData?.refId
                    })
                }
            }
            
        }
    }, [])

    useEffect(() => {
        if (isApp) {
            let data = simpleData?.modules?.find(item => !!item.locationModule);
            // console.log('datat', data)
            if (!!data?.id) {
                document?.getElementById(data?.id)?.scrollIntoView?.({
                    behavior: 'smooth',
                    block: 'center'
                })
            }
        } else {
            if (query?.locationModule) {
                document?.getElementById(query?.locationModule)?.scrollIntoView?.({
                    behavior: 'smooth',
                    block: 'center'
                })
            }
        }
    }, [])

    return <BaseLayout theme={pageSimpleLanding?.simpleData?.theme} modules={simpleData?.modules}>
        {
            simpleData?.modules && simpleData?.modules.length > 0 ? <Moudles data={pageSimpleLanding?.simpleData?.modules} sensors={
                {
                    title: pageSimpleLanding?.simpleData?.refId,
                }
            } /> : <LoadingHome />
        }
    </BaseLayout>
}

SimpleLandingPage.fetchData = async (store, params, search, headers) => {
    const code = search?.code
    const promises = [
        store.dispatch(action_fetch_init_data(code, headers)),
    ]
    const data = await Promise.all(promises)
    return data
}

export default SimpleLandingPage